import * as React from 'react';
import {EmailDataTable} from '../components';
export default () => {
  return (
    <React.Fragment>
      <EmailDataTable />
    </React.Fragment>
  );
};
